import dynamic from 'next/dynamic';
import { BookingAcknowledgementProps } from './BookingAcknowledgement.types';

export const BookingAcknowledgementMGP = dynamic<BookingAcknowledgementProps>(() =>
  import('./BookingAcknowledgement').then(module => module)
);
